export default __webpack_public_path__ + "static/media/sort-alphabetical-descending-selected.23f304d5.svg";